import React from 'react';
import {connect} from 'react-redux'
import {Flex} from '/app/src/component';
import CompanyModel from '/app/src/model/Company/model';

import style from './style.css';

class CancelSubscription extends React.Component
{
    constructor(props){
        super(props);

        this.state = {
            hover: false,
            passwordInput: ''
        }

        this._handleHover = this._handleHover.bind(this);
        this._handleMouseLeave = this._handleMouseLeave.bind(this);
        this._handleButtonClick = this._handleButtonClick.bind(this);
    }

    render()
    {
        return(
            <Flex column grow vAlignContent='center'>
                <Flex column>
                    <Flex column hAlignContent='center'>
                        <h1 className={style.HeaderText}>
                            Vill du verkligen avsluta ditt Jibber-konto?
                        </h1>
                        <Flex className={style.InformationText} column>
                            <p>
                                Ditt nuvarande prisplan kommer inte längre att förnyas.
                                Du får använda Jibber fram tills ditt abonnemangs slutdatum.
                            </p>
                            <p>
                                <br/>
                                Skriv in ditt lösenord och klicka på bekräfta nedan för att avsluta.
                            </p>
                        </Flex>
                    </Flex>
                    {this._renderPasswordField()}
                    {this._renderButton()}
                </Flex>
            </Flex>
        );
    }

    _renderPasswordField(){
        const {passwordInput} = this.state
        return(
            <Flex column hAlignContent='center'>
                <Flex column className={style.PasswordFieldWrapper}>
                Lösenord
                <input className={style.PasswordField} value={passwordInput} onChange={(e) => this.setState({passwordInput: e.target.value})} type="password" name="password" placeholder="Lösenord" />
                </Flex>
            </Flex>
        );
    }

    _renderButton(){
        let icon = '/images/RedCrossMark.png';

        if(this.state.hover){
            icon = '/images/CrossMark.png'
        }
        return(
            <Flex hAlignContent='center' className={style.ButtonWrapper} onMouseOver={this._handleHover} onMouseLeave={this._handleMouseLeave}>
                <button className={style.ButtonStyle} onClick={this._handleButtonClick}>
                    <Flex hAlignContent='center' vAlignContent='center' marginRight='auto'>
                    <img src={icon} alt='icon'/>
                    <Flex marginRight='auto'>Bekräfta</Flex>
                    </Flex>
                </button>
            </Flex>
        )
    }

    _handleHover(){
        this.setState({
            hover: true
        })
    }

    _handleMouseLeave(){
        this.setState({
            hover: false
        })
    }

    _handleButtonClick(){
        this.props.dispatch(CompanyModel.cancelNext(this.state.passwordInput))
    }

}

export default connect()(CancelSubscription);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/CompanySettings/EndSubscription/CancelSubscription.js